<!-- eslint-disable tailwindcss/no-custom-classname -->
<section class="flex w-full cursor-default flex-col gap-2">
  <label class="flex items-center gap-2">
    <sb-icon
      class="h-6 w-6 shrink-0"
      [ngClass]="{
        'text-brand': item.isCompleted,
        'text-grey-200': !item.isCompleted
      }"
      [name]="item.isCompleted ? 'check-circle-solid' : 'circle'"
    />
    <p class="m-0 text-base font-bold">
      @if (listIndex !== undefined) {
        <span>{{ listIndex + 1 }}.</span>
      }
      {{ item.title }}
    </p>
  </label>

  <article class="accordion-animation-wrapper">
    <div class="accordion-animation">
      <div class="accordion-transform-wrapper">
        <div class="flex flex-col gap-3">
          @if (item.subtitle) {
            <p class="m-0 text-support">{{ item.subtitle }}</p>
          }
          @if (item.actions) {
            <div class="flex gap-2">
              @if (item.actions.primary) {
                <button sb-button [color]="'primaryAlt'" (click)="onClick(item.actions.primary.action)">
                  {{ item.actions.primary.text }}
                </button>
              }
              @if (item.actions.secondary) {
                <button sb-button [color]="'secondary'" (click)="onClick(item.actions.secondary.action)">
                  {{ item.actions.secondary.text }}
                </button>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </article>
</section>
